module.exports = __webpack_public_path__ + "789f862be99f33b06f746719811c53c2.png";